import DatePicker from '@mui/lab/DatePicker';
import { ClickAwayListener, TextField } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from "@mui/x-data-grid-premium";
import { useMemo, useRef } from 'react';


interface GridEditDateCellProps extends GridRenderEditCellParams<any, Date | string | null>{
    minDate?: Date
}

export function GridEditDateCell({
    id,
    field,
    value,
    minDate,
  }: GridEditDateCellProps) {
    const apiRef = useGridApiContext();
    const initialValueRef = useRef(value);
    const currentDate = useMemo(() => {
      let now = new Date();
      return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()))
    }, []);
    const enteredDate = !!value ? new Date(value) : value;
    if (!!enteredDate) {
      (enteredDate as Date).setUTCHours(0);
      (enteredDate as Date).setUTCMinutes(0);
      (enteredDate as Date).setUTCSeconds(0);
      (enteredDate as Date).setUTCMilliseconds(0);
    }
  
  
    const handleChange = (newValue: unknown) => {
      apiRef.current.setEditCellValue({ id, field, value: newValue });
    };

    const handleClickAway = () => {
      if (enteredDate && enteredDate < currentDate) {
        apiRef.current.setEditCellValue({ id, field, value: initialValueRef.current });
      }
    }
  
    return (
      <ClickAwayListener onClickAway={handleClickAway}>
        <DatePicker
            clearable
            value={value}
            minDate={minDate}
            onChange={handleChange}
            renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                />
            )}
            mask='__/__/__'
            inputFormat='MM/dd/yy'
        />
      </ClickAwayListener>
    );
  }